<template>
  <div @touchmove="noScoll" v-show="show" class="chartsPlayer"  ref="player">
    <div class="player-bg" :style="style">

      <div @click="toggleFloat" class="charts">
        <div ref="shaojie" class="shaojie">

        </div>
        <div ref="honggan" class="honggan">

        </div>

      </div>
      <div class="floats">
        <div  v-if="float.show" @click="closePlayer" class="close-button">
          <i class="iconfont icon-close"></i>
        </div>
        <div  v-if="float.show" class="table-data">
          <div class="table-data-float">
            <div @touchstart="scrollTable('left')"  class="left"></div>
            <div @touchstart="scrollTable('right')"  class="right"></div>

          </div>
          <div ref="tableList" class="table-data-list">
            <div class="list-header">
              烧结
            </div>
            <div v-for="item in tableData.shaojie" class="list-data">
              <div class="list-th">
                {{item.th}}车位
              </div>
              <div class="list-td">
                {{item.data}}
              </div>
            </div>
            <div class="list-header">
              烘干
            </div>
            <div v-for="item in tableData.honggan" class="list-data">
              <div class="list-th">
                {{item.th}}车位
              </div>
              <div class="list-td">
                {{item.data}}
              </div>
            </div>
          </div>
        </div>
        <div @click="toggleFloat" class="floats-view">

        </div>
        <div  v-if="float.show" class="player-console">
          <div class="player-progress">
            <div :style="{width:progress.width+'%'}" class="progress-bar">
              <div @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd" class="progress-block">
                <p>{{tableData.time_stamp}}</p>
              </div>
            </div>
          </div>
          <div class="player-button">
            <img @click="clickButton('PRE')" src="../../assets/images/pre_icon.png" class="iconfont icon-kuaitui">
            <img v-if="player.status==='PAUSE'" @click="clickButton('PLAY')" src="../../assets/images/play_icon.png"
                 class="iconfont icon-bofang">
            <img v-if="player.status==='STOP'" @click="clickButton('REPLAY')" src="../../assets/images/play_icon.png"
                 class="iconfont icon-zhongxinbofang">
            <img v-if="player.status==='PLAY'" @click="clickButton('PAUSE')" src="../../assets/images/pause_icon.png"
                 class="iconfont icon-zanting">
            <img @click="clickButton('NEXT')" src="../../assets/images/next_icon.png" class="iconfont icon-kuaijin">
          </div>

        </div>

      </div>

    </div>


  </div>
</template>

<script>
const echarts = require("echarts");
export default {
  name: "chartsPlayer",
  props: {
    // data: {
    //   type: Array
    // },
    show: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      data: [],
      index: 0,
      float: {
        show: true
      },
      charts: {
        shaojie: "",
        honggan: ""
      },
      tableData: "",
      player: {
        status: "PAUSE",
        id: ""
      },
      progress: {
        width: 30,
        start: "",
        startWidth: "",
        move: "",
        clientWidth: document.body.clientWidth,
        time_stamp: ""
      },
      style: {},
      isVertical: true
    };
  },
  computed: {
    standData() {
      return this.$store.state.standTempData;
    },
    hisData() {
      return this.$store.state.playerData;
    }
  },
  created() {
    this.getData();
  },

  // watch: {
  //   show() {
  //     this.selectData();
  //     if (this.show) {
  //       // debugger
  //       // this.float.show=false;
  //       this.clickButton('REPLAY')
  //       this.checkDirction()
  //     } else {
  //       this.pausePlayer()
  //     }

  //   }
  // },
  methods: {
    //解决滚动问题
    scrollTable(type) {
      let left=this.$refs.tableList.scrollLeft,
          top=this.$refs.tableList.scrollTop
      if(type==='left'){
        this.$refs.tableList.scrollLeft=left-200
        this.$refs.tableList.scrollTop=top-200
      }else{
        this.$refs.tableList.scrollLeft=left+200
        this.$refs.tableList.scrollTop=top+200
      }
    },
    getData() {
      this.data = this.hisData;
      this.checkDirction();
      this.clickButton("REPLAY");
    },
    // 浮层滚动阻止
    noScoll(e) {
      console.log(123);
      // e.p  reventDefault();
    },
    // 检查横竖屏
    checkDirction() {
      let _this = this;
      let changStyle = () => {
        let width = document.documentElement.clientWidth;
        let height = document.documentElement.clientHeight;
        if (width < height) {
          _this.isVertical = true;
          this.progress.clientWidth = height;
          _this.style = {
            height: width + "px",
            width: height + "px",
            top: (height - width) / 2 + "px",
            left: 0 - (height - width) / 2 + "px",
            transform: "rotate(90deg)",
            "transform-origin": "50% 50%"
          };
        } else {
          this.progress.clientWidth = width;

          _this.isVertical = false;
          _this.style = {
            width: width + "px",
            height: height + "px",
            top: 0 + "px",
            left: 0 + "px",
            transform: "none",
            "transform-origin": "50% 50%"
          };
        }
      };
      changStyle();
      let evt =
        "onorientationchange" in window ? "orientationchange" : "resize";
      window.addEventListener(
        evt,
        function() {
          setTimeout(() => {
            changStyle();
          }, 500);
        },
        false
      );
    },

    toggleFloat() {
      this.float.show = !this.float.show;
    },
    clickButton(type) {
      switch (type) {
        case "PLAY":
          this.playCharts();
          break;
        case "PAUSE":
          this.pausePlayer();
          break;
        case "REPLAY":
          this.index = 0;
          this.selectData();
          this.$nextTick(() => {
            this.playCharts();
          });
          break;
        case "NEXT":
          this.index =
            this.index + 1 < this.data.length ? this.index + 1 : this.index;
          this.selectData();
          break;
        case "PRE":
          this.index = this.index - 1 > 0 ? this.index - 1 : 0;
          this.selectData();
          break;
      }
    },
    playCharts() {
      this.player.id = setInterval(() => {
        if (this.index + 1 < this.data.length) {
          this.player.status = "PLAY";
          this.index++;
          this.selectData();
        } else {
          this.pausePlayer();
          this.player.status = "STOP";
        }
      }, 500);
    },
    pausePlayer() {
      window.clearInterval(this.player.id);
      this.player.status = "PAUSE";
    },

    //选中index后渲染图表和table
    selectData() {
      let index = this.index;
      this.progress.width = (index / this.data.length * 100).toFixed(2);
      this.tableData = this.data[index];
      this.dealChartsData();
    },

    touchStart(e) {
      let touch = e.changedTouches[0];
      console.log(touch);
      this.progress.start = this.isVertical ? touch.clientY : touch.clientX;
      this.progress.startWidth = this.progress.width;
    },
    touchMove(e) {
      let touch = e.changedTouches[0],
        p = this.progress,
        w,
        index;
      w =
        p.startWidth * 1 +
        ((this.isVertical ? touch.clientY : touch.clientX) - p.start) /
          p.clientWidth *
          100;
      index = Math.round(this.data.length * (w / 100));
      if (index < 0) {
        index = 0;
      } else if (index >= this.data.length) {
        index = this.data.length - 1;
      } else {
        this.progress.width = w.toFixed(2);
      }
      // debugger
      this.tableData.time_stamp = this.data[index].time_stamp
        ? this.data[index].time_stamp
        : 0;
    },
    touchEnd(e) {
      let touch = e.changedTouches[0],
        p = this.progress,
        w;
      w =
        p.startWidth * 1 +
        ((this.isVertical ? touch.clientY : touch.clientX) - p.start) /
          p.clientWidth *
          100;
      this.progress.width = w.toFixed(2);
      this.index = Math.round(this.data.length * (w / 100));
      if (this.index < 0) {
        this.index = 0;
      } else if (this.index > this.data.length) {
        this.index = this.data.length - 1;
      }
      this.selectData();
    },

    //整理echarts数据,获取实时曲线，标准曲线，x轴数据
    dealChartsData() {
      let tableData = this.data[this.index],
        stand = this.standData;
      if (tableData) {
        let realData = [],
          xData = [],
          StandData,
          reH,
          reS,
          standH,
          standS;

        //去重取平均值
        function repeatData(data) {
          if (!data.length) {
            return data;
          }
          let json = {},
            item,
            jsonItem;
          for (let i = 0; i < data.length; i++) {
            item = data[i];
            jsonItem = json[item.th];
            if (jsonItem) {
              jsonItem.data=Lib.M.getMax(jsonItem.data, item.data);
              jsonItem.count=1
            } else {
              jsonItem = {};
              jsonItem.th = item.th;
              jsonItem.key = item.key;
              jsonItem.data = item.data;
              jsonItem.count = 1;
            }
            json[item.th] = jsonItem;
          }
          let arr = [],
            arrItem;
          for (let x in json) {
            arrItem = json[x];
            arrItem.data = Math.floor(arrItem.data / arrItem.count);
            arr.push(arrItem);
          }
          return arr;
        }

        /**
         * 对实时数据的处理
         * @argument data
         */
        function dataForEach(data) {
          data = repeatData(data);
          let result = [],
            xData = [],
            DataLength;
          if (data && data.length) {
            // 将间断数据x轴标记为室温，然后将间断数据标记为“-”
            DataLength = data[data.length - 1].th * 1 + 2;
            for (let i = 0; i <= DataLength; i++) {
              if (i === 0) {
                xData[i] = "0";
                result[i] = "30";
              } else if (i === DataLength - 1) {
                xData[i] = "-";
                result[i] = "30";
              } else {
                xData[i] = "-";
                result[i] = "-";
              }
            }
            data.forEach(function(item, n) {
              xData[item.th] = item.th;
              result[item.th] = item.data;
            }, this);
          } else {
            xData = [];
            result = [];
          }
          return { xData, result };
        }

        reH = dataForEach(tableData["honggan"]);
        reS = dataForEach(tableData["shaojie"]);
        standH = dataForEach(stand["honggan"]);
        standS = dataForEach(stand["shaojie"]);
        // 绘图
        this.$nextTick(() => {
          // 当dom存在时渲染
          if (this.$refs.honggan && this.$refs.shaojie) {
            this.initChart("honggan", standH.result, reH.result, reH.xData);
            this.initChart("shaojie", standS.result, reS.result, reS.xData);

            // this.initChart(standH.result,reH.result,standS.result,reS.result,xData);
          }
        });
      }
    },
    // 渲染图表
    initChart(type, standData, realData, xAxisData) {
      // 记录timelineData
      let option = {
        baseOption: {
          grid: {
            show: false,
            top: 20,
            left: 40,
            right: 10,
            bottom: 15
          },
          title:{
            show:type==='shaojie'?true:false,
            text:this.tableData.time_stamp,
            left:45,
            top:30,
            textStyle:{
              color:'#DC143C'
            }
          },
          tooltip: {
            show: false,
            trigger: "axis",
            //  triggerOn: 'none',
            formatter: function(params, ticket, callback) {
              let res,
                th = "车位";
              res = `${params[0].axisValue}${th}</br>`;
              for (let i = 0; i < params.length; i++) {
                res += `${params[i].seriesName}:${params[i].value}</br>`;
              }
              return res;
            }
          },
          legend: {
            show: true,
            data: [
              { name: "标准温度", icon: "rect" },
              { name: "实时温度", icon: "rect" }
            ],
            top: 0,
            right: 0,
            itemHeight: 8,
            itemWidth: 16
          },
          xAxis: {
            show: true,
            data: xAxisData,
            axisPointer: {
              show: false
            },
            axisTick: {
              show: true,
              alignWithLabel: true,
              interval(interval, val) {
                return true;
              }
            },

            axisLabel: {
              show: true,
              rotate: 45,
              interval(index, val) {
                return val != "0" && val !== "-" ? true : false;
              },
              formatter(value, i) {
                return value;
              },
              textStyle: {
                fontSize: 8
              }
            }
          },
          yAxis: {
            show: true,
            axisLine: { show: false },
            splitLine: {
              show: true
            },
            splitNumber: type === "shaojie" ? 4 : 2,
            max: type === "shaojie" ? 1200 : 200,
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: "{value}℃",
              inside: true,
              margin: -30
            }
          },
          series: [
            {
              name: "实时温度",
              type: "line",
              data: realData,
              symbolSize: 8,
              connectNulls: true,
              itemStyle: {
                normal: {
                  color: "#E65D20"
                }
              },
              lineStyle: {
                normal: {
                  width: "2"
                }
              }
            },
            {
              name: "标准温度",
              type: "line",
              data: standData,
              symbolSize: 8,
              connectNulls: true,
              itemStyle: {
                normal: {
                  color: "#2378DC"
                }
              },
              lineStyle: {
                normal: {
                  width: "2"
                }
              }
            }
          ]
        }
      };
      if (this.charts[type]) {
        this.charts[type].setOption(option);
      } else {
        let charts = echarts.init(this.$refs[type], charts, {
          height: type === "shaojie" ? 200 : 100
        });
        charts.setOption(option);
        this.charts[type] = charts;
      }
    },
    closePlayer() {
      // this.$emit('closePlayer')
      this.$router.push("/MtempControl/realData");
    }
  }
};
</script>

<style type="scss" scoped>
.chartsPlayer {
  overflow: auto;
}

.player-bg {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: white;
  top: 0;
  left: 0;
  z-index: 9999;
  transform: translateZ(220px);
  overflow: hidden;
}

.floats {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  z-index: 9999;
  transform: translateZ(120px);
}

.table-data {
  background: rgba(0, 0, 0, 0.8);
  min-height: 35px;
  z-index: 9;
  width: 100%;

}

.floats-view {
  flex: 1;
}
.table-data-float {
  position: absolute;
  top: 0;
  left: 0;
  height: 35px;
  width: 100%;
  display: flex;
}
.table-data-float > div {
  flex: 1;
  z-index: 8;
}

.table-data-list {
  display: flex;
  color: #fff;
  text-align: center;
    webkit-overflow-scrolling: touch;
  overflow-x: scroll;
}


.list-header {
  padding: 5px 10px;
  margin: 0 5px;
  white-space: nowrap;
  font-size: 16px;
}

.list-data {
  padding: 3px 0;
  margin: 0 10px;
  position: relative;
}


.list-th {
  color: #000;
  border-radius: 5px;
  background: #fff;
  padding: 3px 3px;
  white-space: nowrap;
  font-size: 14px;
}

.list-td {
  padding: 2px 0;
}

.player-console {
  background: rgba(0, 0, 0, 0.8);
  min-height: 50px;
  position: relative;
  color: #fff;
}

.player-progress {
  background: rgba(35, 120, 220, 0.5);
  position: absolute;
  height: 5px;
  width: 100%;
  top: -5px;
  left: 0;
}

.progress-bar {
  background: rgba(35, 120, 220, 1);
  height: 5px;
  width: 10%;
  position: relative;
}

.progress-block {
  position: absolute;
  right: -10px;
  top: -2px;
  height: 10px;
  width: 20px;
  background: #fff;
  border-radius: 6px;
}

.progress-block > p {
  padding: 5px;
  font-size: 14px;
  position: absolute;
  white-space: nowrap;
  bottom: -20px;
  left: 0;
}

.player-button {
  text-align: center;
  padding: 20px 0 10px;
}

.player-button .iconfont {
  font-size: 30px;
  margin: 0 25px;
  height: 30px;
}

.close-button {
  position: fixed;
  left: 5%;
  z-index: 99;
  top: 60px;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}

.close-button .iconfont {
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// chartsPlayer.vue?2aaba6dd